var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"total":_vm.total,"attr":{
    dense: true,
    'no-data-text': _vm.$t('rules.noData'),
    'item-key': 'id',
    class: 'table-cus-footer',
  },"itemsPerPage":10,"itemsPerPageOptions":[10, 20, 30, 50, 100, 200, 500],"headers":_vm.headers,"items":_vm.items,"defaultSortBy":"status","funReset":_vm.loadData},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_index,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }